import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Loader2Icon, PlusIcon, SearchIcon } from 'lucide-react';
import { Button, buttonClasses } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { formatDate } from '../../utils/format';
const ease = [0.23, 1, 0.32, 1] as const;
export function Customers() {
  const {
    customers,
    casesForCustomer,
    createCustomer
  } = useAdminData();
  const [query, setQuery] = useState('');
  const [creating, setCreating] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    notes: ''
  });
  const term = query.trim().toLowerCase();
  const visible = customers.filter(customer => !term ? true : `${customer.name} ${customer.phone} ${customer.email} ${customer.address}`.toLowerCase().includes(term));
  return <div className="px-5 py-7 md:px-8 md:py-10" data-id="element-631" data-mp="1cqytmxdp3rub">
      <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-632" data-mp="1cq7bao93zqlz">
        <div data-id="element-633" data-mp="1qix010g0v9ms">
          <p className="text-sm text-ink-muted" data-id="element-634" data-mp="1qhc3j5a5dgma">{customers.length} kunder</p>
          <h1 className="mt-1 font-display text-[clamp(1.8rem,5vw,2.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-635" data-mp="1lisg10fwnwrt">
            Kunder
          </h1>
        </div>
        <Button size="md" onClick={() => setCreating(value => !value)} data-id="element-636" data-mp="xvj6lcbj8w7f">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-637" data-mp="ttxo9bg8bppu" />
          Opret kunde
        </Button>
      </div>

      {creating && <motion.form initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.24,
      ease
    }} className="mt-6 rounded-card border border-line bg-white p-6" onSubmit={async event => {
      event.preventDefault();
      if (saving) return;
      setSaving(true);
      setError('');
      const created = await createCustomer(form);
      setSaving(false);
      if (!created) {
        setError('Kunden kunne ikke gemmes. Tjek din forbindelse, og prøv igen.');
        return;
      }
      setForm({
        name: '',
        phone: '',
        email: '',
        address: '',
        notes: ''
      });
      setCreating(false);
    }} data-id="element-638" data-mp="12ssx6vanrdwu">
          <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-639" data-mp="22m9ctd4u5qgx">Ny kunde</h2>
          <div className="mt-5 grid gap-5 sm:grid-cols-2" data-id="element-640" data-mp="27kj95r2aqx44">
            <TextField id="nk-navn" label="Navn" required value={form.name} onChange={event => setForm({
          ...form,
          name: event.target.value
        })} data-id="element-641" data-mp="2cj48lo9q5cri" />
            <TextField id="nk-tlf" label="Telefonnummer" type="tel" value={form.phone} onChange={event => setForm({
          ...form,
          phone: event.target.value
        })} data-id="element-642" data-mp="1jt5idpjsn9l9" />
            <TextField id="nk-mail" label="E-mail" type="email" value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} data-id="element-643" data-mp="1h7o5l3mvnl6q" />
            <TextField id="nk-adresse" label="Adresse" value={form.address} onChange={event => setForm({
          ...form,
          address: event.target.value
        })} data-id="element-644" data-mp="12czvtdag20lb" />
            <TextField id="nk-noter" label="Noter" className="sm:col-span-2" value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} data-id="element-645" data-mp="tj4ygrfkdeg8" />
          </div>
          {error && <p role="alert" className="mt-4 text-[15px] text-danger" data-id="element-646" data-mp="en5jqxxy8g24">
              {error}
            </p>}
          <div className="mt-6 flex gap-3" data-id="element-647" data-mp="amllts5jx8ex">
            <Button type="submit" disabled={saving} data-id="element-648" data-mp="zbyc19lb0ncs">
              {saving ? <>
                  <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-649" data-mp="14b1h2u1aatkr" />
                  Gemmer …
                </> : 'Gem kunde'}
            </Button>
            <Button type="button" variant="secondary" onClick={() => setCreating(false)} data-id="element-650" data-mp="ukq30envz405">
              Annuller
            </Button>
          </div>
        </motion.form>}

      <div className="mt-6" data-id="element-651" data-mp="gntb09w17gho">
        <label htmlFor="kundesoeg" className="sr-only" data-id="element-652" data-mp="lktkyvw053e2">
          Søg i kunder
        </label>
        <div className="flex items-center gap-2 rounded-xl border border-line bg-white px-4 py-3" data-id="element-653" data-mp="7laavxjmrhz4">
          <SearchIcon className="h-4 w-4 shrink-0 text-ink-faint" aria-hidden="true" data-id="element-654" data-mp="blu9z6nrkvnw" />
          <input id="kundesoeg" value={query} onChange={event => setQuery(event.target.value)} placeholder="Søg på navn, telefon, mail eller adresse" className="w-full bg-transparent text-[15px] text-ink placeholder:text-ink-faint focus:outline-none" data-id="element-655" data-mp="21z2yeuyph7q4" />
        </div>
      </div>

      <div className="mt-6 rounded-card border border-line bg-white" data-id="element-656" data-mp="3mif4pqehrapw">
        <div className="hidden md:block" data-id="element-657" data-mp="434m1444a3hm">
          <table className="w-full text-left text-[15px]" data-id="element-658" data-mp="44xqqdv66dmz">
            <thead data-id="element-659" data-mp="3vghbkmkwoxl3">
              <tr className="border-b border-line text-xs uppercase tracking-wider text-ink-muted" data-id="element-660" data-mp="3vfz8p73qnl47">
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-661" data-mp="dzhbfpsmpv6k">Navn</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-662" data-mp="90watp9gt9hl">Telefon</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-663" data-mp="n28qs0omlb3h">E-mail</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-664" data-mp="i2mcrp0z3qtm">Adresse</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-665" data-mp="i3fdo9d93m3u">Sager</th>
                <th scope="col" className="px-5 py-3 font-medium" data-id="element-666" data-mp="2otv97dugbxoc">Seneste sag</th>
                <th scope="col" className="px-5 py-3" data-id="element-667" data-mp="2jusasc8z8ppc" />
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-668" data-mp="nrnofb0q4zm6">
              {visible.map(customer => {
              const list = casesForCustomer(customer.id);
              const latest = [...list].sort((a, b) => b.createdAt.localeCompare(a.createdAt))[0];
              return <tr key={customer.id} className="transition-colors duration-200 ease-smooth hover:bg-canvas" data-id="element-669" data-mp="11qdi0goc4h5s">
                    <td className="px-5 py-3.5 font-medium text-ink" data-id="element-670" data-mp="16qi4cnbxc63x">{customer.name}</td>
                    <td className="whitespace-nowrap px-5 py-3.5 text-ink-soft" data-id="element-671" data-mp="1bo9tj9l6pe4f">{customer.phone || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-672" data-mp="1gf9q2dqe5u6e">{customer.email || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-673" data-mp="1lf4i4klwkpt1">{customer.address || '—'}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-674" data-mp="1pghpiz4n9122">{list.length}</td>
                    <td className="px-5 py-3.5 text-ink-soft" data-id="element-675" data-mp="1pedb3n94cjnj">
                      {latest ? `${latest.title} · ${formatDate(latest.createdAt)}` : '—'}
                    </td>
                    <td className="px-5 py-3.5 text-right" data-id="element-676" data-mp="3eymyery6han8">
                      <Link to={`/admin/kunder/${customer.id}`} className={buttonClasses('secondary', 'sm')} data-id="element-677" data-mp="39xz5g0qe2jqd">
                        Åbn
                      </Link>
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>

        <ul className="divide-y divide-line md:hidden" data-id="element-678" data-mp="1iozuinaiwdu">
          {visible.map(customer => {
          const list = casesForCustomer(customer.id);
          return <li key={customer.id} data-id="element-679" data-mp="3ov9hpcauvtn5">
                <Link to={`/admin/kunder/${customer.id}`} className="block px-5 py-4" data-id="element-680" data-mp="3ou85h4i3t13u">
                  <p className="text-[15px] font-medium text-ink" data-id="element-681" data-mp="3jx7viii4ve7g">{customer.name}</p>
                  <p className="mt-0.5 text-sm text-ink-muted" data-id="element-682" data-mp="l6y2xnqdgms4">{customer.phone}</p>
                  <p className="mt-1 text-sm text-ink-soft" data-id="element-683" data-mp="gfpp8fi0ef95">
                    {list.length} {list.length === 1 ? 'sag' : 'sager'}
                  </p>
                </Link>
              </li>;
        })}
        </ul>

        {visible.length === 0 && <p className="px-5 py-12 text-center text-sm text-ink-muted" data-id="element-684" data-mp="3ppk87y5h4235">Ingen kunder matcher søgningen.</p>}
      </div>
    </div>;
}